import * as Device from "expo-device";
import {
  lockAsync,
  OrientationLock,
  addOrientationChangeListener,
} from "expo-screen-orientation";
import { Platform } from "react-native";

export async function setupOrientationLock() {
  if (Platform.OS === "web") {
    return;
  }
  await lock();
  addOrientationChangeListener(() => {
    lock();
  });
}

async function lock() {
  if (Platform.OS === "ios" && Platform.isPad) {
    lockAsync(OrientationLock.DEFAULT)
      .then(() => {})
      .catch((e) => {
        console.warn("Could not lock orientation", e);
      });
    return;
  }

  try {
    const isTablet =
      (await Device.getDeviceTypeAsync()) === Device.DeviceType.TABLET;

    lockAsync(isTablet ? OrientationLock.DEFAULT : OrientationLock.PORTRAIT_UP)
      .then(() => {
        console.log("Orientation locked");
      })
      .catch((e) => {
        console.warn("Could not lock orientation", e);
      });
  } catch (e) {
    console.log("setupOrientationLock", e);
    lockAsync(OrientationLock.PORTRAIT)
      .then(() => {})
      .catch((e) => {
        console.warn("Could not lock orientation", e);
      });
  }
}
